module.exports = __webpack_public_path__ + "static/hero-mobile-a1f4c15850ccd7f89bd3cbc5ea059446.jpg";